import React, { useEffect, useRef, useState } from 'react';
import { Card } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import SingleNotification from './SingleNotification';
import NoNotification from './NoNotification';
import { fetchAlertList } from './redux/dispatcher';
import alertNotificationImg from '../../assets/img/alertnotification.png'
import NotificationModal from 'components/dashboard/NotificationModal';

function AlertNotification() {
    const dispatch = useDispatch();
    const alertState = useSelector((state) => state.alertNotificationReducer);
    const [page, setPage] = useState(1);
    const isFetching = useRef(false);
    const [selectedNotification, setSelectedNotification] = useState();
    const [image, setImage] = useState();

    const alertData = Array.isArray(alertState?.alerts) ? alertState.alerts : [];
    const isLoading = alertState?.loading;
    const hasMore = alertState?.page < alertState?.totalPage;

    useEffect(() => {
        dispatch(fetchAlertList({ page: 1, limit: 10 }));
    }, [dispatch]);

    useEffect(() => {
        if (page > 1) {
            dispatch(fetchAlertList({ page, limit: 10 }));
        }
    }, [page, dispatch]);

    useEffect(() => {
        if (!isLoading) {
            isFetching.current = false;
        }
    }, [isLoading]);

    useEffect(() => {
        setImage(alertData.find(n => n.id === selectedNotification));
    }, [selectedNotification]);

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop - clientHeight < 80 && !isFetching.current && hasMore) {
            isFetching.current = true;
            setPage(prev => prev + 1);
        }
    };

    return (
        <>
            <Card className='alert_notification_card'>
                <div className='d-flex align-items-center ml-3 mb-4 mt-2'>
                    <img src={alertNotificationImg} alt="alert" style={{ width: '24px', marginLeft: '10px', marginTop: '5px' }} />
                    <h2 className='ml-3 mb-0 mt-2 alert-notification-head'>Alerts</h2>
                </div>
                <div style={{ overflowY: 'auto', marginBottom: '0px', marginRight: '5px' }} onScroll={handleScroll}>
                    {
                        alertData.length === 0 && !isLoading ? (
                            <NoNotification />
                        ) : (
                            alertData
                                .filter(item => item?.type)
                                .map(item => (
                                    <SingleNotification setSelectedNotification={setSelectedNotification} key={item?.id} data={item} />
                                ))
                        )
                    }
                    {isLoading && (
                        <div style={{ textAlign: 'center', padding: '10px', color: '#666' }}>
                            Loading...
                        </div>
                    )}
                </div>
            </Card>

            {image &&
                <NotificationModal open={true} toggle={() => setSelectedNotification(null)} notificationData={image} />
            }
        </>
    );
}

export default AlertNotification;
